import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {Object} props
 * @param {import("utils/types").TextSize} props.size
 * @param {import("utils/types").Weight} props.weight
 * @param {import('utils/types').Shade} props.variant
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Text({
  size = 'md',
  weight = 'normal',
  variant = 800,
  children = '',
  className = ''
}) {
  if (!children) return null;

  return (
    <p
      data-size={size}
      data-weight={weight}
      style={{ color: `var(--gray-${variant})` }}
      className={cn(styles.container, className)}
    >
      {children}
    </p>
  );
}
